import { render } from "./CardApi.vue?vue&type=template&id=b5e9a878"
import script from "./CardApi.vue?vue&type=script&lang=js"
export * from "./CardApi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\TAfolabi\\Documents\\Projects\\legacy\\partner\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__